export const COLLABORATOR_ROLE = {
  administrator: 1,
  legal_representative: 2,
}
